import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/coupon',
    component: () => import('../views/Home/Home.vue')
  },
  {
    path: '/merchant/trappistdairy',
    name: 'trappistdairy',
    component: () => import('../views/homePage/homePage.vue')
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: () => import('../views/couponPage/couponPage.vue')
  },
  {
    path: '/merchant/oto',
    name: 'merchantOTO',
    component: () => import('../views/merchantOTO/merchantOTO.vue')
  },
  {
    path: '/merchant/:merchantId',
    name: 'merchant',
    component: () => import('../views/merchant/merchant.vue')
  },
  {
    path: '/coupon/:couponId',
    name: 'couponInfo',
    component: () => import('../views/couponDetail/index.vue')
  },
  {
    path: '/coupon/oto/:couponId',
    name: 'couponOTOInfo',
    component: () => import('../views/couponOTODetail/index.vue')
  },
  {
    path: '/banner',
    name: 'banner',
    component: () => import('../views/couponPage/component/mainContent.vue')
  },
  {
    path: '/footer',
    name: 'footer',
    component: () => import('../views/couponDetail/index.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order/order.vue')
  },
  {
    path: '/order/:orderId',
    name: 'thank',
    component: () => import('../views/thank/thank.vue')
  },
  {
    path: '/email',
    name: 'email',
    component: () => import('../views/email/email.vue')
  },
  {
    path: '/member',
    name: 'member',
    redirect: '/member/coupon',
    component: () => import('../views/member/member.vue'),
    children: [
      {
        path: 'coupon',
        name: 'msCoupon',
        component: () => import('../views/member/component/coupon.vue'),
        meta: { hash: 'msCoupon' }
      }, {
        path: 'voucher',
        name: 'msVoucher',
        component: () => import('../views/member/component/voucher.vue'),
        meta: { hash: 'msVoucher' }
      }, {
        path: 'campaign',
        name: 'msGiftCard',
        component: () => import('../views/member/component/giftCard.vue'),
        meta: { hash: 'msGiftCard' }
      }
    ]
  }, {
    path: '/voucher',
    name: 'voucher',
    component: () => import('../views/voucher/voucher.vue')
  }, {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacy/privacy.vue')
  }, {
    path: '/appPayment/:orderId',
    name: 'appOrder',
    component: () => import('../views/appOrder/appOrder.vue')
  }
]

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    const nameArr = ['msCoupon', 'msVoucher', 'msGiftCard']
    if (nameArr.indexOf(from.name) !== -1 && to.name !== from.name) {
      return {
        selector: '#' + to.meta.hash,
        behavior: 'smooth'
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  const routerGuardNameArr = ['msCoupon', 'msVoucher', 'msGiftCard']
  if (routerGuardNameArr.includes(to.name)) {
    if (localStorage.getItem('token')) {
      next()
    } else {
      next(from.path)
    }
  }
  next()
})

export default router
